import { Icons } from '@/components/common/icons'
import { Button, buttonVariants } from '@/components/ui/button'
import { Card, CardContent } from '@/components/ui/card'
import { useCart } from '@/hooks/use-cart'
import { formatPrice } from '@/lib/utils'
import { CartItem } from '@/types/cart'
import { Cross1Icon } from '@radix-ui/react-icons'
import Link from 'next/link'

const CartProductList = ({ items }: { items: CartItem[] }) => {
  const removeItem = useCart((state) => state.removeItem)
  const decreaseQuantity = useCart((state) => state.decreaseQuantity)
  const addItem = useCart((state) => state.addItem)
  // console.log("Items ", items)
  return (
    <Card>
      {items.length == 0 ?
        <CardContent className='flex flex-col justify-center items-center w-full h-full'>
          <div aria-hidden="true" className='relative mb-4 h-40 w-40 text-muted-foreground'>
            <Icons.emptyCart className='w-full h-full text-gray-800' />
          </div>
          <h3 className='font-semibold text-2xl'>Your cart is empty</h3>
          <Link prefetch={false} href={"/products"} className={buttonVariants({
            variant: "link",
            size: "sm"
          })}>
            Add items to your cart to checkout
          </Link>
        </CardContent>
        :
        <ul>
          {
            items.map(({ product, quantity }) => {
              return (
                <li key={product.productId} className='flex p-4'>
                  <div className='flex-shrink-0 w-32 h-32 bg-slate-200 rounded-md overflow-hidden'>
                    {product.thumbnail?.url && <img loading='lazy' className='w-full h-full object-cover object-center' src={product.thumbnail.url} alt='Product image' />}
                  </div>
                  <div className='ml-4 flex flex-1 flex-col justify-center sm:ml-6'>
                    <div className='relative pr-9 sm:grid sm:grid-cols-2 sm:gap-x-6 sm:pr-0'>
                      <div>
                        <div className='flex justify-between'>
                          <h3 className='text-sm'>
                            <Link className='font-semibold text-gray-700 hover:text-gray-800' href={`/products/${product.slug}`}>{product.name}</Link>
                          </h3>
                        </div>
                        <div className='mt-1 flex text-sm space-x-4'>
                          <p className='text-muted-foreground'>{product.unit}</p>
                        </div>

                        <p className='mt-1 text-sm font-medium text-gray-900'>
                          {formatPrice(product.price)}
                        </p>
                        <div className='flex border mt-4 w-fit text-center '>
                          <Button onClick={()=>{decreaseQuantity(product)}} size={"sm"} variant={"ghost"}>{"-"}</Button>
                          <p className='border-l self-center border-r px-4'>{quantity}</p>
                          <Button onClick={() => addItem(product)} size={"sm"} variant={"ghost"}>{"+"}</Button>
                        </div>

                        <div className='mt-4 sm:mt-0 sm:pr-9 w-20'>
                          <div className='absolute right-0 top-0'>
                            <Button variant={"ghost"} onClick={() => { removeItem(product.productId) }} aria-label='Remove product'>
                              <Cross1Icon className='h-5 w-5' aria-hidden="true" />
                            </Button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>
              )
            })
          }

        </ul>
      }
    </Card>

  )
}

export default CartProductList